export const REPORT_TYPES = {
  PHR: 0,
  SANKEY: 1,
  NARRATIVE: 2,
  IP: 3
}

export const REPORT_TYPES_LABEL = {
  [REPORT_TYPES.PHR]: 'Population Health Report',
  [REPORT_TYPES.SANKEY]: 'Sankey Report',
  [REPORT_TYPES.NARRATIVE]: 'Narrative Report',
  [REPORT_TYPES.IP]: 'Interactive Publication'
}

export const REPORT_TYPES_SELECT_OPTIONS = [
  { value: REPORT_TYPES.PHR, label: REPORT_TYPES_LABEL[REPORT_TYPES.PHR] },
  { value: REPORT_TYPES.SANKEY, label: REPORT_TYPES_LABEL[REPORT_TYPES.SANKEY] },
  { value: REPORT_TYPES.NARRATIVE, label: REPORT_TYPES_LABEL[REPORT_TYPES.NARRATIVE] },
  { value: REPORT_TYPES.IP, label: REPORT_TYPES_LABEL[REPORT_TYPES.IP] }
]

export const REPORT_VIEWERS = {
  IFRAME: 0,
  MARKDOWN: 1,
  PAGE_LIST: 2,
  PAGE: 3,
  IFRAME_SUBFOLDER: 4,
  DEMO_PAGE_LIST: 5,
  DEMO_PAGE: 6,
  EXECUTIVE_SUMMARY_PAGE: 7
}

export const REPORT_VIEWER_MODE = {
  READ: 0,
  WRITE: 1
}

export const REPORT_STATUS = {
  DRAFT: 0,
  PUBLISHED: 1
}

export const REPORT_STATUS_LABEL = {
  [REPORT_STATUS.DRAFT]: 'Draft',
  [REPORT_STATUS.PUBLISHED]: 'Published'
}

export const PAGE_CONTROL_BAR_KEY = 'page_control_bar'

export const REPORT_ROLE = {
  OWNER: 'owner',
  WRITER: 'writer',
  REVIEWER: 'reviewer',
  READER: 'reader'
}
